import React from 'react';
import PropTypes from 'prop-types';

import cn from 'utils/classnames';

import styles from './Card.module.scss';

function Card(props) {
  const { className, children } = props;

  return (
    <section className={cn(styles.Component, className)}>
      {children}
    </section>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Card.defaultProps = {
  className: '',
};

export default React.memo(Card);
